import React, {useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import {useDispatch, useSelector} from 'react-redux';
import * as S from './PopupHeader.styles';
import IconSelector from 'icon-selector/src/icon-selector';
import SessionTimer from './SessionTimer';
import SelectLanguage from '../../GccComponents/SelectLanguage/SelectLanguage';
import useRedirect from '../../../../../pages/Onboarding/hooks/useRedirection';
import {
  tokenSelector,
  directLandingSelector,
  statusSelector,
  errorSelector,
  sessionExpireSelector,
} from '../../../../../store/selectors';
import {uploadPassportInfoError} from '../../../../../store/actions/onboarding';

const PopupHeader = ({step, editNumber, showLanguageSelector}) => {
  const dispatch = useDispatch();
  const sessionExpiry = useSelector(sessionExpireSelector);
  const error = useSelector(errorSelector);
  const [popUp, showModal, setShowModal] = useRedirect();

  const [showTimer, setShowTimer] = useState(sessionExpiry != 0);
  const goBack = () => {
    // const history = useHistory();
    // let evarStr = ""
    // if(step == 2) {
    //   evarStr = "myPartner|signup|OTPVerification|previousStep"
    // } else if (step == 3) {
    //   evarStr = "myPartner|signup|businessVerification|previousStep"
    // }
    sendEvarData(
      {
        prop54: 'myPartner_onboarding_back',
      },
      true,
    );
    if (error) {
      dispatch(uploadPassportInfoError({}));
    }
    history.back();
  };

  const totalSteps = 3;

  let borderDiv = null;
  switch (step) {
    case 1:
      borderDiv = <S.SignUpStepIndicator />;
      break;
    case 2:
      borderDiv = <S.SignUpStepIndicatorTwo />;
      break;
    case 3:
      borderDiv = <S.SignUpStepIndicatorThree />;
      break;
    default:
      borderDiv = null;
      break;
  }

  const showStep = step === 1 || step === 2 || step === 3;

  return (
    <S.PopHeaderMainWrap>
      {showStep && (
        <S.PopHeaderWrap alignRight={step === 2 || step === 3 ? true : false}>
          {step === 2 || step === 3 ? (
            <S.PopHeaderBackWrap onClick={goBack} alignRight={true}>
              <IconSelector iconKey="back" />
              <S.PopHeaderBackText>Back</S.PopHeaderBackText>
            </S.PopHeaderBackWrap>
          ) : (
            <S.PopHeaderBackWrap onClick={editNumber} alignRight={false}>
              <S.PopHeaderBackText>Close</S.PopHeaderBackText>
            </S.PopHeaderBackWrap>
          )}

          <S.PopHeaderStepWrap disabled={step === 1 ? true : false}>
            {showTimer && <SessionTimer error={error} modal={showModal} showModal={setShowModal} />}
            {/* <S.PopHeaderSessionWrap>
                            <S.PopHeaderSessionText>Session expires in :<span>17m 54s</span></S.PopHeaderSessionText>
                        </S.PopHeaderSessionWrap> */}
            <S.PopHeaderStepInnerWrap>
              <S.PopHeaderStepText>
                STEP{' '}
                <span>
                  {step} OF {totalSteps}
                </span>
              </S.PopHeaderStepText>
              <S.SignUpStepIndicatorWrap>{borderDiv}</S.SignUpStepIndicatorWrap>
            </S.PopHeaderStepInnerWrap>
          </S.PopHeaderStepWrap>
        </S.PopHeaderWrap>
      )}
    </S.PopHeaderMainWrap>
  );
};

export default PopupHeader;
